module.exports = __webpack_public_path__ + "85e2dd052cc61da41a78f6a4f0a568d4.png";